<template>
  <div style="overflow: hidden">
    <p class="title">محدوده {{ selectedZone.title }}</p>
    <vs-row>
      <vs-col vs-justify="center" vs-align="center" vs-w="6">
        قیمت منطقه (ریال):
        <vs-input v-model="cost" class="w-100 mt-1" :disabled="freeFee" />
      </vs-col>
      <vs-col vs-w="12" style="margin-top: -1rem">
        <vs-checkbox :value="freeFee" v-model="freeFee">سرویس دهی رایگان در این محدوده</vs-checkbox>
      </vs-col>
      <vs-col>
        <div class="flex justify-end align-center">
          <vs-button @click="selectedFee ? update() : save()" color="primary" block icon-pack="feather"
            icon="icon-check" class="mr-5">{{ selectedFee ? "بروزرسانی" : "ذخیره" }}</vs-button>
          <vs-button v-if="selectedFee" @click="deleteItem()" color="danger" block icon-pack="feather" icon="icon-x">حذف
          </vs-button>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import providerApiService from "../../services/api/ProviderApiService";

export default {
  name: "DeliveryCost",
  data() {
    return {
      freeFee: this.selectedFee
        ? this.selectedFee.fee === 0
          ? true
          : false
        : false,

      cost: this.selectedFee
        ? this.selectedFee.fee
            .toString()
            .splitNumberFormat()
            .numberFormat()
        : null,
    };
  },
  components: {},
  methods: {
    save() {
      const cost = this.cost.splitNumberFormat();
      this.$vs.loading();
      providerApiService
        .storeOrUpdateProviderPolygon(
          this.currentProvider.id,
          this.selectedZone.id,
          null,
          cost
        )
        .then((result) => {
          this.$emit("itemAdded", result.resource);
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    update() {
      let cost = this.cost.splitNumberFormat();
      if (this.freeFee) {
        cost = 0;
      }
      
      this.$vs.loading();
      providerApiService
        .storeOrUpdateProviderPolygon(
          this.currentProvider.id,
          this.selectedZone.id,
          this.selectedFee.id,
          cost,
          true
        )
        .then((result) => {
          this.$emit("itemUpdated", result.resource);
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    deleteItem() {
      this.$vs.loading();

      providerApiService
        .deleteDeliveryFee(
          this.currentProvider.id,
          this.selectedZone.id,
          this.selectedFee.id
        )
        .then(() => {
          this.$emit("itemDeleted", this.selectedFee);
          this.$vs.notify({
            text: "عملیات با موفقیت انجام شد.",
            color: "success",
            position: "bottom-center",
          });
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  watch: {
    cost(newValue) {
      this.cost = newValue
        .toString()
        .splitNumberFormat()
        .numberFormat();
    },
    freeFee(newValue) {
      if (newValue) {
        this.cost = 0;
      }
    },
  },
  props: {
    selectedZone: {
      required: true,
      type: Object,
    },
    selectedFee: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  font-size: 1.2rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 20px;
}
</style>
